export const VENUE_MAP_BACKGROUND_APP_V2 = { uri: '/images/VenueMapBackgroundAppV2.png' }
